import React from "react";
import { WviState } from "./AgGridContainer";

export const WviContext = React.createContext<{
  wviState: WviState;
}>({
  wviState: {},
});
